import { defineRoute } from "src/routing/defineRoute";

/**
 * Path + typed URL builder pairs for migrated `/developments` URLs.
 *
 * Kept separate from `developments.ts` (the `RouteObject` tree) so `RouteUrls.ts` and pages can
 * import paths without creating a cycle through page `Component` imports.
 *
 * Development detail (`/developments/:developmentId/*`) still lives in legacy `routesDef.ts`
 * (`developmentPaths`) until that SideNav tree migrates.
 */
export const developmentsRoute = defineRoute("/developments");
